import { Outlet } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from '@/redux/store';
import ClearHelmetSeoOnNavigation from '@/routes/ClearHelmetSeoOnNavigation';
import EnhancedRouteTracker from '@/components/analytics/EnhancedRouteTracker';
import CartPanel from '@/components/ui/CheckoutAndOrderManagement/CartPanel';

// Create a wrapper that will hold the EnhancedRouteTracker at the app level
// This ensures only one instance is active at a time
export const AppLayout = () => {
  return (
    <>
      <ClearHelmetSeoOnNavigation />
      <Outlet />
      <EnhancedRouteTracker />
    </>
  );
};

export const ConditionalCartPanel = () => {
  const authState = useSelector((state: RootState) => state.auth);

  if (authState.ready && authState.token) {
    return <CartPanel />;
  }
  return null;
};
